/**
 * Fixed Assets permission keys (catalog `assets.*` and the asset reports `rpt.*`, docs/contracts/fixed-assets.md §5).
 * The API checks the same keys; creating, posting and approving a document are separate (FA19, G3, D7a).
 */
export const assetsPermissions = {
  classView: "assets.asset_class.view",
  classCreate: "assets.asset_class.create",
  classUpdate: "assets.asset_class.update",
  classDelete: "assets.asset_class.delete",
  assetView: "assets.assets_archive.view",
  assetCreate: "assets.assets_archive.create",
  assetUpdate: "assets.assets_archive.update",
  assetDelete: "assets.assets_archive.delete",
  assetPrint: "assets.assets_archive.print",
  assetHistory: "assets.assets_archive.history",
  acquisitionView: "assets.asset_purchase.view",
  settlementView: "assets.auc_settlement.view",
  transferView: "assets.assets_movement.view",
  saleView: "assets.asset_sell.view",
  scrapView: "assets.asset_stock_out_damage.view",
  impairmentView: "assets.impairment.view",
  revaluationView: "assets.revaluation.view",
  depreciationView: "assets.depreciation_run.view",
  depreciationRun: "assets.depreciation_run.run",
  depreciationReverse: "assets.depreciation_run.reverse",
  countView: "assets.asset_count.view",
  countCreate: "assets.asset_count.create",
  countUpdate: "assets.asset_count.update",
  countPost: "assets.asset_count.post",
  countDelete: "assets.asset_count.delete",
  tagView: "assets.asset_tag.view",
  tagCreate: "assets.asset_tag.create",
  tagPrint: "assets.asset_tag.print",
  leaseView: "assets.right_of_use.view",
  leaseCreate: "assets.right_of_use.create",
  leaseUpdate: "assets.right_of_use.update",
  leasePost: "assets.right_of_use.post",
  leaseDelete: "assets.right_of_use.delete",
  leaseReverse: "assets.right_of_use.reverse",
  leaseSettle: "assets.right_of_use.settle",
  leaseRemeasure: "assets.right_of_use.remeasure",
  maintenanceView: "assets.maintainance.view",
  maintenanceCreate: "assets.maintainance.create",
  maintenanceUpdate: "assets.maintainance.update",
  maintenanceCapitalise: "assets.maintainance.capitalise",
  requestView: "assets.maintenance_request.view",
  requestCreate: "assets.maintenance_request.create",
  requestUpdate: "assets.maintenance_request.update",
  registerView: "rpt.asset_register.view",
  rollForwardView: "rpt.asset_roll_forward.view",
  forecastView: "rpt.depreciation_forecast.view",
  leaseMaturityView: "rpt.lease_maturity.view",
} as const;

/** The document actions of one kind (`assets.<feature>.<action>`). */
export type DocumentAction = "view" | "create" | "update" | "delete" | "post" | "approve" | "reverse" | "print";

/** Plan module of Fixed Assets. */
export const assetsModule = "assets";
